import ClientTaskDisplay from './ClientTaskDisplay';

export default ClientTaskDisplay;